import { render, staticRenderFns } from "./Karin-Denunciation-count-graph.vue?vue&type=template&id=3a4ba33c&scoped=true"
import script from "./Karin-Denunciation-count-graph.vue?vue&type=script&lang=js"
export * from "./Karin-Denunciation-count-graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ba33c",
  null
  
)

export default component.exports